import { render, staticRenderFns } from "./MyColorPicker.vue?vue&type=template&id=6c68af04&scoped=true&"
import script from "./MyColorPicker.vue?vue&type=script&lang=js&"
export * from "./MyColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c68af04",
  null
  
)

export default component.exports